export default {
    setConnectedAccounts(state, payload) {
        state.connectedYoutubeAccounts = payload;
    },
    setClientDetails(state, payload) {
        state.authUrl = payload;
    }
}